import { clsx, type ClassValue } from "clsx";

/** Joins conditional class names. A thin wrapper so call sites read `cn(...)`. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
